import type {
  GetMappedDefect,
  DecisionToolModalProps,
  DecisionToolModalVisibleDefect,
} from "./DecisionToolModal.type";
import type { DecisionToolVisibleDefect } from "@/components/FormEngine/Editor/DragAndDropTool/Field/Severity/DefectSuggestions/DecisionTool/DecisionTool/DecisionTool.type";

import { Modal, Typography } from "antd";
import { useTranslation } from "react-i18next";

import DecisionTool from "@/components/FormEngine/Editor/DragAndDropTool/Field/Severity/DefectSuggestions/DecisionTool/DecisionTool";

const { Title } = Typography;

const DecisionToolModal = ({
  visible,
  onCancel,
  selectedMaterial,
  visibleDefects,
  datasetsImage = [],
}: DecisionToolModalProps) => {
  const { t } = useTranslation();

  const getMappedDefect: GetMappedDefect = (
    visibleDefects: DecisionToolModalVisibleDefect[] = []
  ) => {
    const mappedDefects: DecisionToolVisibleDefect[] = visibleDefects.map(
      (defect) => ({
        defect: defect.value ?? "",
        name: defect.label || "",
        confidence: defect.confidence,
        suggested: defect.suggested,
      })
    );
    return mappedDefects;
  };

  return (
    <Modal
      title={
        <Title level={2}>
          {t("form:staticField.defectSuggestion.decisionTool")}
        </Title>
      }
      className="decision-tool-modal"
      open={visible}
      onCancel={onCancel}
      destroyOnHidden
      footer={null}
      width="100%"
    >
      <DecisionTool
        selectedMaterial={selectedMaterial}
        visibleDefects={getMappedDefect(visibleDefects)}
        datasetsImage={datasetsImage}
      />
    </Modal>
  );
};

export default DecisionToolModal;
